'use client';

import { type FC, useContext } from 'react';

import { useMediaQuery } from '../../hooks/use-media-query';
import { FormFieldContext } from '../form-field';
import { DatePickerRootContext } from './context/date-picker-root.context';
import { useDatePicker } from './hooks/use-date-picker';
import type { DatePickerRootPropsInterface } from './types/date-picker-root.types';

/**
 * @since 10.0.0
 */
export const DatePickerRoot: FC<DatePickerRootPropsInterface> = (
  props: DatePickerRootPropsInterface,
) => {
  const formFieldContext = useContext(FormFieldContext);

  const {
    children,
    closeModalOnDateSelect: _closeModalOnDateSelect,
    dateFormat = 'MM/dd/yyyy',
    defaultValue: _defaultValue,
    disabled = formFieldContext.disabled || false,
    disabledDates,
    error = formFieldContext.error || false,
    maxDate,
    minDate,
    modal = true,
    onValueChange: _onValueChange,
    open: _open,
    readOnly = formFieldContext.readOnly || false,
    required = formFieldContext.required || false,
    size = 'md',
    value: _value,
    useDismissProps: _useDismissProps,
    defaultOpen: _defaultOpen,
    onOpenChange: _onOpenChange,
  } = props;

  const datePicker = useDatePicker(props);

  const isSmallBreakpoint = useMediaQuery('only screen and (max-width : 30em)');

  return (
    <DatePickerRootContext.Provider
      value={{
        datePicker,
        dateFormat,
        disabled,
        disabledDates,
        error,
        maxDate,
        minDate,
        modal: modal && isSmallBreakpoint,
        readOnly,
        required,
        size,
      }}
    >
      {children}
    </DatePickerRootContext.Provider>
  );
};

DatePickerRoot.displayName = 'DatePicker.Root';
